import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { Alert } from '../../ui/Alert';

export const ContactFormModal = ({ contact, onSave, onClose }) => {
  const [values, setValues] = useState({
    full_name: contact?.full_name || '',
    email: contact?.email || '',
    phone: contact?.phone || '',
    company: contact?.company || '',
    job_title: contact?.job_title || ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const set = (key) => (e) => setValues((v) => ({ ...v, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!values.full_name.trim()) {
      setError('Full name is required.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await onSave(values);
    } catch (err) {
      setError(err.message || 'Could not save this contact.');
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/40 p-0 sm:p-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-6 space-y-4 max-h-[92vh] overflow-y-auto shadow-xl"
      >
        <h2 className="text-xl font-bold text-slate-900 tracking-tight">
          {contact ? 'Edit contact' : 'Add contact'}
        </h2>
        {error && <Alert variant="error" message={error} />}
        <Input label="Full name *" value={values.full_name} onChange={set('full_name')} maxLength={300} autoFocus />
        <Input label="Email" type="email" value={values.email} onChange={set('email')} maxLength={320} />
        <Input label="Phone" type="tel" value={values.phone} onChange={set('phone')} maxLength={50} />
        <Input label="Company" value={values.company} onChange={set('company')} maxLength={300} />
        <Input label="Job title" value={values.job_title} onChange={set('job_title')} maxLength={300} />
        <div className="flex justify-end gap-3 pt-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={saving}>Cancel</Button>
          <Button type="submit" isLoading={saving}>{contact ? 'Save changes' : 'Add contact'}</Button>
        </div>
      </form>
    </div>
  );
};